"use strict";

exports.__esModule = true;
exports.default = void 0;

var _Cache = _interopRequireDefault(require("../Cache"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cache = new _Cache.default();

function getScrollOffset(selector) {
  return new Promise(function (resolve) {
    resolve(cache.getSelector(selector).map(function (node) {
      return {
        scrollTop: node.scrollTop,
        scrollLeft: node.scrollLeft,
        scrollWidth: node.scrollWidth,
        scrollHeight: node.scrollHeight
      };
    }));
  });
}

function getBoundingClientRect(selector) {
  return new Promise(function (resolve) {
    resolve(cache.getSelector(selector).map(function (node) {
      return node.getBoundingClientRect();
    }));
  });
}

var _default = {
  getScrollOffset: getScrollOffset,
  getBoundingClientRect: getBoundingClientRect
};
exports.default = _default;